module.exports = __webpack_public_path__ + "img/canadian-flag-icon.fb82c591.svg";